import { RxCustomerAPI, RxBillingAPI, BillingAPI, checkStatus, json } from '@drifthq/dapper'

export const api = {
  updateBilling(recurlyTokenId) {
    return RxCustomerAPI
      .post('/billing/billing_info', { billingToken: recurlyTokenId })
      .checkStatus()
      .retryWithBackoff()
  },
  upgrade(planCode) {
    return RxCustomerAPI
      .post('/billing/upgrade/2018/04', { planCode })
      .checkStatus()
      .retryWithBackoff()
  },
  fetchBillingDeal(dealCode) {
    return BillingAPI.get(`/deals/${dealCode}`)
      .then(checkStatus)
      .then(json)
  },
  fetchContract(contractId) {
    return BillingAPI.get(`/contracts/${contractId}`)
      .then(checkStatus)
      .then(json)
  },
  activateDeal({ dealId, billingToken, accessToken }) {
    return RxBillingAPI.post(`/deals/activate`, { dealId, billingToken }, {headers: { Authorization: `Bearer ${accessToken}` }})
      .checkStatus()
  },
}



// WEBPACK FOOTER //
// ./src/modules/billing/api.js